import { createContext, useContext, useEffect, useId } from 'react';
export const ProfitBusyContext = createContext<(id: string, busy: boolean) => void>(() => {});
export function useProfitBusy(busy: boolean) {
  const report = useContext(ProfitBusyContext);
  const id = useId();
  useEffect(() => { report(id, busy); return () => report(id, false); }, [id, busy, report]);
}
